import React, { useState, useEffect } from 'react';
import Navbar from '../../components/navbar';
import Footer from '../../components/Footer';
import './ICAIMPage.css';

const stats = [
  { value: '90+', label: 'Research Papers', detail: 'High-quality papers on interdisciplinary subjects', icon: 'document' },
  { value: '47+', label: 'Posters', detail: 'Innovative ideas and research presentations', icon: 'user' },
  { value: '3+', label: 'Global Partners', detail: 'AMC, MACCIA, and NCSH', icon: 'globe' },
  { value: 'Blended', label: 'Conference Mode', detail: 'Virtual & In-person participation', icon: 'group' },
  { value: 'Empowerment', label: 'Vision Focus', detail: 'Women empowerment in rural & urban sectors', icon: 'eye' },
];

const heroHighlights = ['Women Empowerment', 'Sustainable Agriculture', 'Healthcare', 'Digital Literacy', 'AI Skills'];

const themes = [
  {
    title: 'Agriculture',
    description: 'Empowering women in agriculture through IT solutions, millet processing, and sustainable farming.',
    tone: 'green',
  },
  {
    title: 'Healthcare',
    description: 'Promoting green hospitals, rural health, hygiene, and leveraging AI for transforming medical practice.',
    tone: 'blue',
  },
  {
    title: 'Information Technology',
    description: 'Utilizing NLP, Power BI, AWS, predictive analytics, and digital literacy to drive sustainability.',
    tone: 'violet',
  },
];

const preConferenceSchedule = [
  { date: '05-02-2024', time: '10:00 - 11:00 am', topic: 'Role of Women Empowerment in Rural India - Health, Finance & Literacy', speaker: 'Ms. Rupali Deshmukh, Scientist Food & Nutrition, KVK, Palghar' },
  { date: '06-02-2024', time: '10:00 - 11:00 am', topic: 'Role of Good Health and Diet in Empowering Women', speaker: 'Ms. Jennifer Dhuri, Dietician/Nutritionist' },
  { date: '07-02-2024', time: '10:00 - 11:00 am', topic: 'Women Empowerment in Rural areas through Millet processing', speaker: 'Er. Anuja Divate, Subject Matter Specialist (Agricultural Engineering) KVK, Palghar' },
  { date: '08-02-2024', time: '10:00 - 11:00 am', topic: 'Role of KVK in Empowering Women in Rural India', speaker: 'Dr. Vilas Jadhav, Senior Scientist & Head, KVK, Dahanu' },
  { date: '08-02-2024', time: '11:00 - 12:00 am', topic: 'Importance of Millet in Daily Life', speaker: 'Ms Anupama Padhi, Founder and CEO Dhani Foods' },
  { date: '09-02-2024', time: '9:00 - 11:30 am', topic: 'The Millet Movement in TIMSCDR Recipe Competition', speaker: 'Ms Anupama Padhi, Founder and CEO Dhani Foods' },
  { date: '09-02-2024', time: '1:30 - 2:15 pm', topic: 'AI Skill Lab Inauguration', speaker: 'Mr Akash Kamal (Dell Technologies) & Mr Vikrant Aloni' },
  { date: '09-02-2024', time: '2:00 - 5:00 pm', topic: 'Hackathon', speaker: 'Faculties, TIMSCDR' },
  { date: '06, 07 & 08 Feb 2024', time: 'Workshop', topic: 'Microsoft Power BI & AWS Workshop', speaker: 'Faculty members, TIMSCDR' }
];

const sessionChairs = [
  'Dr Mishu Tripathi, HOD at TIMSR',
  'Dr Astha Sharma, Asst. Professor at TIMSR',
  'Dr. Dinesh Kumar Singh, Group Leader, TCS',
  'Dr. Suresh A. Shan, Chairman, CSI - Mumbai Chapter',
  'Dr Abdul Moid, Director ERTL WEST',
  'Mr Smith Gonsalves, Cyber Security Expert, Cyber Smith SECURE'
];

const paperAwards = [
  { category: 'Faculty - 1st Prize', title: 'Study of Leveraging IT for enhancing literacy to empower tribal women in the Sange village of Palghar district of the State of Maharashtra', authors: 'Dr. Vinita Gaikwad, Ms. Anamika Dhawan, Ms. Shweta Waghmare' },
  { category: 'Faculty - 2nd Prize', title: "Sentiment Analysis for Education for analyzing students' feedback", authors: 'Ms. Rupali Jadhav, Dr. Rupal Parekh' },
  { category: 'Faculty - 3rd Prize', title: 'A Review on Software-Driven Solution for Authentication and Authorization in the Google Play Store', authors: 'Mr. Shirshendu Maitra, Dr. Padma Nilesh Mishra' },
  { category: 'Student - 1st Prize', title: 'Study of NLP models and their efficacy in the detection of early signs of depression and suicidal tendencies.', authors: 'Atman Shastri' },
  { category: 'Student - 2nd Prize', title: 'Uncovering the Dark Patterns of Persuasive Design (UI/UX)', authors: 'Arjun Sharma' },
  { category: 'Student - 3rd Prize', title: 'Empowering Farmers: An Intelligent Crop Recommendation System Based on Predictive Analytics', authors: 'Aditya Salaria' },
];

const posterAwards = [
  { category: 'Student - 1st Prize', title: 'IOT Based alarming system for hospitals (Role of IT)', authors: 'Yadav Sanjana, Yadav Sanyog, Yadav Sudha, Dubey Aryan' },
  { category: 'Student - 2nd Prize', title: 'Menstrual Hygiene and Access to Sanitary Products for School Going Girls (Role of IT)', authors: 'Kshatriya Ananya, Mishra Gaurav, Pal Rahul, Singh Aachal' },
  { category: 'Student - 3rd Prize', title: 'Elevating Maternal Well-Being Navigating Factors', authors: 'Kotre Siddhi, Mayekar Aditya' },
  { category: 'Student - 3rd Prize', title: 'Early Detection of Breast Cancer using ML Techniques & AI', authors: 'Dholam Sayli, Fernandes Josephine, Gaud Sonal, Gupta Annapurna' },
];

const partners = ['AMC', 'MACCIA', 'NCSH'];

// ---> UPDATED GALLERY IMAGES
const galleryCards = [
  { title: 'Inauguration Ceremony', src: '/ICAIM/ICAIM2024/imgi_3_PRI06196-scaled.jpg' },
  { title: 'Keynote Speakers', src: '/ICAIM/ICAIM2024/imgi_4_PRI06262-scaled.jpg' },
  { title: 'Panel Discussion', src: '/ICAIM/ICAIM2024/imgi_10_PRI06564-scaled.jpg' },
  { title: "Doctor's Workshop", src: '/ICAIM/ICAIM2024/imgi_7_PRI06223-scaled.jpg' },
  { title: 'Paper Presentations', src: '/ICAIM/ICAIM2024/imgi_11_PRI06720-scaled.jpg' }
];

// ---> UPDATED CAROUSEL IMAGES
const carouselImages = [
  '/ICAIM/ICAIM2024/imgi_13_PRI06174-scaled.jpg',
  '/ICAIM/ICAIM2024/imgi_9_PRI06213-scaled.jpg',
  '/ICAIM/ICAIM2024/imgi_5_pre-conference-session2-scaled.jpg'
];

const icon = (kind) => {
  const common = { fill: 'none', stroke: 'currentColor', strokeWidth: '1.9', strokeLinecap: 'round', strokeLinejoin: 'round' };
  if (kind === 'calendar') return <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="2" {...common} /><path d="M8 3v4M16 3v4M3 10h18" {...common} /></svg>;
  if (kind === 'location') return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s6-5.4 6-11a6 6 0 1 0-12 0c0 5.6 6 11 6 11Z" {...common} /><circle cx="12" cy="10" r="2.5" {...common} /></svg>;
  if (kind === 'document') return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 3h7l4 4v14H7V3Z" {...common} /><path d="M14 3v5h5M10 13h6M10 17h6M10 9h2" {...common} /></svg>;
  if (kind === 'user') return <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="4" {...common} /><path d="M5 21c1.2-4 4-6 7-6s5.8 2 7 6" {...common} /></svg>;
  if (kind === 'globe') return <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9" {...common} /><path d="M3 12h18M12 3c2.2 2.4 3.3 5.4 3.3 9S14.2 18.6 12 21M12 3c-2.2 2.4-3.3 5.4-3.3 9S9.8 18.6 12 21" {...common} /></svg>;
  if (kind === 'group') return <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="9" cy="9" r="3.2" {...common} /><circle cx="17" cy="10" r="2.6" {...common} /><path d="M3.5 21c.9-3.9 3-6 5.5-6s4.6 2.1 5.5 6M14.5 16c2.4.2 4.2 1.9 5 5" {...common} /></svg>;
  if (kind === 'eye') return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2.5 12s3.6-6 9.5-6 9.5 6 9.5 6-3.6 6-9.5 6-9.5-6-9.5-6Z" {...common} /><circle cx="12" cy="12" r="3" {...common} /></svg>;
  if (kind === 'arrow') return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" {...common} /></svg>;
  if (kind === 'leaf') return <svg width="36" height="36" stroke="#ffffff" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 14c0-5.5 4.5-10 10-10h4v4c0 5.5-4.5 10-10 10H5v-4Z" {...common} /><path d="M8 16c3-5 6-7 11-10" {...common} /></svg>;
  if (kind === 'medical') return <svg width="36" height="36" stroke="#ffffff" viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="3" width="14" height="18" rx="2" {...common} /><path d="M12 8v8M8 12h8" {...common} /></svg>;
  if (kind === 'chip') return <svg width="36" height="36" stroke="#ffffff" viewBox="0 0 24 24" aria-hidden="true"><rect x="7" y="7" width="10" height="10" rx="2" {...common} /><path d="M9 1v4M15 1v4M9 19v4M15 19v4M1 9h4M1 15h4M19 9h4M19 15h4" {...common} /></svg>;
  if (kind === 'download') return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" {...common} /></svg>;
  return null;
};

const Icaim24 = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % carouselImages.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);

  const handleScrollToSection = (event, sectionId) => {
    event.preventDefault();
    const target = document.getElementById(sectionId);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="icaim25Page icaim24Page">
      <Navbar />
      <main className="icaim25Main">
        <section className="icaim25Hero">
          <div className="icaim25HeroShell glass-panel-dark">
            <div className="icaim25HeroGrid" id="icaim25-content">
              <div className="icaim25HeroCopy">
                <span className="icaim25HeroKicker">ICAIM 2024</span>
                <h1 className="icaim25HeroLead">
                  IT for Sustainability &amp; Empowerment
                </h1>
                <p className="icaim25HeroSubtitle">
                  Technology-led solutions for agriculture, healthcare, and women's empowerment.
                </p>

                <div className="icaim25HeroHighlights" aria-label="Conference focus areas">
                  {heroHighlights.map((highlight) => (
                    <span key={highlight}>{highlight}</span>
                  ))}
                </div>

                <div className="icaim25HeroMetaInline">
                  <div className="icaim25MetaItemInline">
                    <span className="icaim25MetaIconInline">{icon('calendar')}</span>
                    <span>10 - 11 February 2024</span>
                  </div>

                  <span className="icaim25MetaSeparator">|</span>

                  <div className="icaim25MetaItemInline">
                    <span className="icaim25MetaIconInline">{icon('location')}</span>
                    <span>TIMSCDR, Mumbai (Blended Mode)</span>
                  </div>
                </div>

                <div className="icaim25HeroActions">
                  <a
                    href="#overview"
                    className="icaim25PrimaryButton text-center"
                    style={{ textDecoration: 'none' }}
                    onClick={(event) => handleScrollToSection(event, 'overview')}
                  >
                    <span>Explore Conference</span>
                    <span className="icaim25ButtonIcon">{icon('arrow')}</span>
                  </a>
                  <a
                    href="#publications"
                    className="icaim25SecondaryButton text-center"
                    style={{ textDecoration: 'none' }}
                    onClick={(event) => handleScrollToSection(event, 'publications')}
                  >
                    <span>View Publications</span>
                    <span className="icaim25ButtonIcon">{icon('document')}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="icaim25StatsSection" id="about">
          <div className="icaim25StatsGrid glass-panel-light">
            {stats.map((stat, index) => (
              <div className="icaim25StatCard" key={stat.label}>
                <div className={`icaim25StatIcon statTone${index + 1}`}>{icon(stat.icon)}</div>
                <div>
                  <div className="icaim25StatValue">{stat.value}</div>
                  <div className="icaim25StatLabel">{stat.label}</div>
                  <div className="icaim25StatDetail">{stat.detail}</div>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="icaim25AboutSection" id="overview">
          <div className="icaim25AboutGrid">
            <div className="icaim25SectionIntro">
              <span className="icaim25SectionTag">Conference Overview</span>
              <h2>Empowering Women through Technology and Sustainability.</h2>
              <p>
                Thakur Institute of Management Studies, Career Development and Research (TIMSCDR) organized <strong>ICAIM 2024</strong> on 10-11 February 2024. The conference was a unique virtual interdisciplinary event exploring how IT solutions can be leveraged in Agriculture and Healthcare with a strong perspective on <strong>Women's Empowerment</strong>.
              </p>
              <p>
                Arranged in association with AMC, MACCIA, and the Nordic Center for Sustainable Healthcare (NCSH), the event brought together leading experts to address the cutting-edge directions for IT in these crucial domains.
              </p>
            </div>

            <div className="icaim25StageCard glass-panel-light" aria-hidden="true">
              <div className="icaim25StageHeader">ICAIM 2024</div>
              <div className="icaim25StageScreen">
                <div className="icaim25CarouselTrack">
                  {carouselImages.map((img, index) => (
                    <img
                      key={index}
                      src={img}
                      alt={`Conference slide ${index + 1}`}
                      className={`icaim25CarouselImg ${index === currentSlide ? 'active' : ''}`}
                    />
                  ))}
                  <div className="icaim25CarouselOverlay"></div>
                </div>
                <div className="icaim25StageAudience" />
              </div>
            </div>
          </div>
        </section>

        <section className="icaim25ThemeSection">
          <div className="icaim25CenteredHeading">
            <span className="icaim25SectionTag">Theme Focus</span>
          </div>
          <div className="icaim25ThemeGrid">
            {themes.map((theme, index) => (
              <article className={`icaim25ThemeCard tone-${theme.tone}`} key={theme.title}>
                <div className="icaim25ThemeCardIcon">
                  {icon(index === 0 ? 'leaf' : index === 1 ? 'medical' : 'chip')}
                </div>
                <h3>{theme.title}</h3>
                <p>{theme.description}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="icaim25NarrativeSection" id="events">
          <div className="icaim25CenteredHeading" style={{ marginTop: '50px' }}>
            <span className="icaim25SectionTag">Event Highlights</span>
          </div>
          <div className="icaim25NarrativeGrid">
            <article className="icaim25NarrativeCard glass-panel-light">
              <div className="icaim25PanelHeader">
                <span className="icaim25PanelTag" style={{ color: 'var(--icaim-accent)' }}>Day 1 - 10 February 2024</span>
                <h3 style={{ marginTop: '8px', fontSize: '1.6rem', color: 'var(--icaim-text)' }}>Inauguration & Sustainability Focus</h3>
              </div>
              <p>
                Guest of Honor <strong>Dinesh Kumar Singh</strong> (TCS) inaugurated the conference, highlighting education in women's empowerment. Speakers <strong>Ms. Ritu Rungta</strong> and <strong>Miss Rasika Phatak</strong> focused on empowering women in IT and agriculture.
              </p>
              <p>
                <strong>Mr. Johannes Brunding</strong> (NCSH) and <strong>Dr. Shantanu Sharma</strong> (Lund University) emphasized green hospitals and a cleaner environment. <strong>Dr. Padmaja Samant</strong> (KEM Hospital) spoke on women's health, and <strong>Dr. Sangeeta Shirname</strong> discussed the Literacy Project in tribal Padas.
              </p>
              <p>
                A panel discussion featuring <strong>Mrs. Anjali Churi</strong> and <strong>Ms. Rekha Mohnot</strong> summarized women's empowerment across literacy, healthcare, agriculture, and finance.
              </p>
            </article>

            <article className="icaim25NarrativeCard glass-panel-light">
              <div className="icaim25PanelHeader">
                <span className="icaim25PanelTag" style={{ color: 'var(--icaim-accent)' }}>Day 2 - 11 February 2024</span>
                <h3 style={{ marginTop: '8px', fontSize: '1.6rem', color: 'var(--icaim-text)' }}>Empowering Doctors with Technology</h3>
              </div>
              <p>
                Chief Guest <strong>Dr. Ashok Shukla</strong> (President AMC) gave an opening speech on bridging gaps between doctors and technology, joined by dignitaries including <strong>Dr. Vikrant Desai</strong>, <strong>Dr. Mukesh Gupta</strong>, and <strong>Dr. Jayesh Lele</strong>. 
              </p>
              <p>
                A panel on "Empowering Doctors with Technology" included <strong>Dr. Hemal Maniar</strong>, <strong>Mr. Manoj Sharma</strong>, <strong>Jaimin Bhatt</strong>, and <strong>Dr. Vinita Gaikwad</strong>. Sessions by <strong>Prof. Sonu Gupta</strong> (SEO) and <strong>Prof. Mira Gohil</strong> (Dark Web Safety) provided crucial digital insights.
              </p>
              <p>
                The day concluded with a Doctor's Workshop on the <strong>"Use of AI in Daily Practise for Doctors"</strong>, providing hands-on training to medical professionals from across Mumbai.
              </p>
            </article>
          </div>
        </section>

        <section className="icaim25FeatureSection" id="speakers">
          <div className="icaim25FeatureGrid">
            <article className="icaim25DarkPanel glass-panel-dark">
              <div className="icaim25PanelHeader">
                <span className="icaim25PanelTag">Workshops &amp; Special Events</span>
                <h2>Applied learning and skill development.</h2>
              </div>
              <div className="icaim25WorkshopGrid">
                <div className="icaim25WorkshopCard highlight-green">
                  <h3>Doctor&apos;s Workshop</h3>
                  <p>Use of AI in Daily Practice for Doctors, empowering medical professionals with modern tools.</p>
                  <ul>
                    <li>Role of AI in transforming Medical Practice</li>
                    <li>AI for Personal Enhancement</li>
                    <li>AI Tools for Doctors in Practice</li>
                    <li>AI for Social Media Marketing</li>
                    <li>UPI Platform: Do's & Don'ts</li>
                  </ul>
                </div>
                <div className="icaim25WorkshopCard highlight-orange">
                  <h3>Technical Workshops & Hackathon</h3>
                  <p>Hands-on sessions on AWS, Power BI, and collaborative hackathons for students.</p>
                  <div className="icaim25JudgesBlock">
                    <strong>Highlights</strong>
                    <span>Microsoft Power BI & AWS Workshop (6-8 Feb)</span>
                    <span>AI Skill Lab Inauguration (Dell Technologies)</span>
                    <span>Millet Movement Recipe Competition</span>
                  </div>
                </div>
              </div>
            </article>

            <article className="icaim25NarrativeCard glass-panel-light" id="pre-conference">
              <div className="icaim25PanelHeader">
                <span className="icaim25PanelTag" style={{ color: 'var(--icaim-primary)' }}>Pre-Conference</span>
                <h3 style={{ marginTop: '8px', fontSize: '1.6rem', color: 'var(--icaim-text)' }}>Expert Sessions</h3>
              </div>
              <p style={{ marginBottom: '16px' }}>
                Conducted for students by eminent industry personalities focusing on rural empowerment, health, and cutting-edge technology.
              </p>
              <div className="icaim25TableWrap glass-table">
                <table className="icaim25Table">
                  <thead>
                    <tr>
                      <th>Date / Time</th>
                      <th>Topics</th>
                      <th>Speaker Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    {preConferenceSchedule.map((session, i) => (
                      <tr key={i}>
                        <td><strong>{session.date}</strong><br /><span style={{ fontSize: '0.85em', color: 'var(--icaim-text-muted)' }}>{session.time}</span></td>
                        <td>{session.topic}</td>
                        <td>{session.speaker}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </article>
          </div>
        </section>

        <section className="icaim25ResearchSection" id="awards">
          <div className="icaim25CenteredHeading" style={{ marginTop: '80px' }}>
            <span className="icaim25SectionTag">Proceedings & Recognitions</span>
            <h2 style={{ fontSize: '2.2rem', marginTop: '10px' }}>90 Research Papers & 47 Technical Posters</h2>
            <p style={{ color: 'var(--icaim-text-muted)', maxWidth: '700px', margin: '10px auto' }}>
              Selected after a rigorous review process and presented before distinguished professionals from Agriculture, Healthcare, and IT sectors.
            </p>
          </div>

          <div className="icaim25SessionChairs" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center', marginBottom: '40px' }}>
            {sessionChairs.map((chair, i) => (
              <span key={i} className="icaim25Badge">{chair}</span>
            ))}
          </div>

          <div className="icaim25AwardsStack">
            <article className="icaim25NarrativeCard glass-panel-light">
              <h3 style={{ color: 'var(--icaim-primary)', marginBottom: '16px' }}>Research Paper Awards</h3>
              <div className="icaim25TableWrap glass-table">
                <table className="icaim25Table">
                  <thead>
                    <tr>
                      <th>Award Category</th>
                      <th>Research Paper Title</th>
                      <th>Authors</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paperAwards.map((award, i) => (
                      <tr key={i}>
                        <td><strong style={{ color: award.category.includes('1st Prize') ? 'var(--icaim-accent)' : 'inherit' }}>{award.category}</strong></td>
                        <td>{award.title}</td>
                        <td>{award.authors}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </article>

            <article className="icaim25NarrativeCard glass-panel-light">
              <h3 style={{ color: 'var(--icaim-primary)', marginBottom: '16px' }}>Technical Research Poster Awards</h3>
              <div className="icaim25TableWrap glass-table">
                <table className="icaim25Table">
                  <thead>
                    <tr>
                      <th>Award Category</th>
                      <th>Poster Title</th>
                      <th>Authors</th>
                    </tr>
                  </thead>
                  <tbody>
                    {posterAwards.map((award, i) => (
                      <tr key={i}>
                        <td><strong style={{ color: award.category.includes('1st Prize') ? 'var(--icaim-accent)' : 'inherit' }}>{award.category}</strong></td>
                        <td>{award.title}</td>
                        <td>{award.authors}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </article>
          </div>
        </section>

        <section className="icaim25PublicationsSection" id="publications">
          <div className="icaim25CenteredHeading">
            <span className="icaim25SectionTag">Publications</span>
            <h2 style={{ fontSize: '2rem', marginTop: '10px' }}>List of Journal Publication for ICAIM - 2024</h2>
            <p style={{ color: 'var(--icaim-text-muted)', maxWidth: '600px', margin: '15px auto 30px' }}>
              Access the official published book featuring all the outstanding interdisciplinary research papers and technical posters from the ICAIM 2024 conference.
            </p>
            <a 
              href="/path/to/ICAIM-2024-Journal-Publication.pdf" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="icaim25PrimaryButton" 
              style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', textDecoration: 'none' }}
            >
              <span className="icaim25ButtonIcon" style={{ margin: 0 }}>{icon('download')}</span>
              <span>Download Published Book (PDF)</span>
            </a>
          </div>
        </section>

        <section className="icaim25PartnersSection">
          <div className="icaim25CenteredHeading">
            <span className="icaim25SectionTag">Our Partners &amp; Associations</span>
          </div>
          <div className="icaim25PartnersGrid">
            {partners.map((partner) => (
              <div className="icaim25PartnerCard glass-panel-light" key={partner}>
                <div className="icaim25PartnerMark">{partner.charAt(0)}</div>
                <div className="icaim25PartnerName">{partner}</div>
              </div>
            ))}
          </div>
        </section>

        <section className="icaim25GallerySection" id="gallery">
          <div className="icaim25CenteredHeading">
            <span className="icaim25SectionTag">Glimpses From ICAIM 2024</span>
          </div>
          <div className="icaim25GalleryGrid">
            {galleryCards.map((card, index) => (
              <div className={`icaim25GalleryCard gallery-${index + 1}`} key={card.title}>
                <img src={card.src} alt={card.title} />
                <span>{card.title}</span>
              </div>
            ))}
          </div>
        </section>

      </main>

      <Footer />
    </div>
  );
};

export default Icaim24;